import { render } from "./AppBarcodeReader.vue?vue&type=template&id=c21a455e&scoped=true"
import script from "./AppBarcodeReader.vue?vue&type=script&lang=js"
export * from "./AppBarcodeReader.vue?vue&type=script&lang=js"

import "./AppBarcodeReader.vue?vue&type=style&index=0&id=c21a455e&scoped=true&lang=css"

import exportComponent from "/Users/alpha/Documents/IONS/project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21a455e"]])

export default __exports__